import React from "react";
import {
  Select,
  Label,
  Input,
  Text,
  Checkbox,
  makeStyles,
} from "@fluentui/react-components";
import { CoverageComponentProps } from "./types";

const useStyles = makeStyles({
  rightAlignedInput: {
    "& input": {
      textAlign: "right",
    },
  },
});

const GapCoverage: React.FC<CoverageComponentProps<"gap">> = ({
  config,
  onConfigChange,
  t,
  classes,
}) => {
  const styles = useStyles();

  // Format number with thousands separators
  const formatNumber = (num: number | undefined): string => {
    if (num === undefined || num === null || num === 0) return "";
    return num.toLocaleString("cs-CZ");
  };

  // Parse formatted string back to number
  const parseFormattedNumber = (value: string): number => {
    const cleaned = value.replace(/\s/g, "").replace(/,/g, "");
    return parseInt(cleaned) || 0;
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "16px",
          alignItems: "flex-end",
          justifyContent: "flex-start",
          marginBottom: "16px",
        }}
      >
        <div
          className={classes.fieldGroup}
          style={{ flex: "0 0 calc(33.33% - 8px)" }}
        >
          <Label htmlFor="gapType" required style={{ marginBottom: "4px" }}>
            GAP insurance type
          </Label>
          <Select
            id="gapType"
            value={config.gapType || "gap"}
            onChange={(_, data) =>
              onConfigChange({
                gapType: data.value,
              })
            }
          >
            <option value="gap">GAP</option>
            <option value="gapWithDeductible">GAP with deductible</option>
          </Select>
        </div>

        <div
          className={classes.fieldGroup}
          style={{ flex: "0 0 calc(33.33% - 8px)" }}
        >
          <Label
            htmlFor="vehiclePurchasePrice"
            required
            style={{ marginBottom: "4px" }}
          >
            Vehicle purchase price
          </Label>
          <Input
            id="vehiclePurchasePrice"
            className={styles.rightAlignedInput}
            value={formatNumber(config.vehiclePurchasePrice)}
            onChange={(_, data) => {
              const numValue = parseFormattedNumber(data.value);
              onConfigChange({
                vehiclePurchasePrice: numValue,
              });
            }}
            contentAfter={<Text>Kč</Text>}
            placeholder="Enter purchase price"
          />
        </div>

        <div style={{ flex: "0 0 calc(33.33% - 8px)" }}></div>
      </div>

      <div style={{ marginTop: "8px" }}>
        <Checkbox
          label="Include GAP-U Financial Loss Insurance"
          checked={config.includeFinancialLoss || false}
          onChange={(_, data) => {
            onConfigChange({
              includeFinancialLoss: data.checked === true,
            });
          }}
        />
      </div>
    </>
  );
};

export default GapCoverage;
